import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=647b3687&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=647b3687&prod&scoped=scoped&lang=less"
import style1 from "./Index.vue?vue&type=style&index=1&id=647b3687&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647b3687",
  null
  
)

export default component.exports